import type { ProductKind } from '@iheartjane/taxonomy';

export const CATEGORIES_ORDER: ProductKind[] = [
  'flower',
  'edible',
  'pre-roll',
  'extract',
  'tincture',
  'topical',
  'vape',
  'grow',
  'gear',
  'merch',
];
